export default __webpack_public_path__ + "static/kolumna-bg-f15c04495d044e45a6f98035d143dcd3.png";